import { liberisAgreementsNames } from '@repo/shared/types';
import { LIBERIS_LINK, LIBERIS_PRIVACY_POLICY_LINK } from '@repo/shared/constants';

import { MODAL_STATE } from '@/components/modal/modal.store';

import { LiberisToPayproTerms } from './liberis-to-paypro-terms';
import { PayproToLiberisTerms } from './paypro-to-liberis-terms';

export const agreements = [
  {
    title: 'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.bureau',
    name: liberisAgreementsNames.enum['agreements.bureau'],
    link: LIBERIS_PRIVACY_POLICY_LINK,
  },
  {
    title: 'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.marketing',
    name: liberisAgreementsNames.enum['agreements.liberisMarketing'],
    link: LIBERIS_LINK,
  },
  {
    title:
      'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.payProToLiberisData.title',
    name: liberisAgreementsNames.enum['agreements.payProToLiberisData'],
    type: MODAL_STATE.LOAN_AGREEMENTS,
    modalBodyChildren: <PayproToLiberisTerms />,
  },
  {
    title:
      'welcomePage.loanApplicationPossible.liberis.agreementsForm.agreements.liberisDataToPayPro.title',
    name: liberisAgreementsNames.enum['agreements.liberisDataToPayPro'],
    modalBodyChildren: <LiberisToPayproTerms />,
    type: MODAL_STATE.LOAN_AGREEMENTS,
  },
];
